const LayersThree01 = ({ width, height, color }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 16 16"
      width={width || "16"}
      height={height || "16"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1376_5705)">
        <path
          d="M1.33301 8.00037L7.76116 11.2144C7.84862 11.2582 7.89234 11.28 7.93821 11.2886C7.97883 11.2963 8.02052 11.2963 8.06114 11.2886C8.10701 11.28 8.15073 11.2582 8.23819 11.2144L14.6663 8.00037M1.33301 11.3337L7.76116 14.5478C7.84862 14.5915 7.89234 14.6134 7.93821 14.622C7.97883 14.6296 8.02052 14.6296 8.06114 14.622C8.10701 14.6134 8.15073 14.5915 8.23819 14.5478L14.6663 11.3337M1.33301 4.66704L7.76116 1.45296C7.84862 1.40923 7.89234 1.38737 7.93821 1.37876C7.97883 1.37114 8.02052 1.37114 8.06114 1.37876C8.10701 1.38737 8.15073 1.40923 8.23819 1.45296L14.6663 4.66704L8.23819 7.88111C8.15073 7.92484 8.10701 7.9467 8.06114 7.95531C8.02052 7.96293 7.97883 7.96293 7.93821 7.95531C7.89234 7.9467 7.84862 7.92484 7.76116 7.88111L1.33301 4.66704Z"
          stroke={color || "#232D2D"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1376_5705">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default LayersThree01;
